module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifDemi.45bfded4.woff2";